<label for="text">
  Context target for report template: (e.g. $.data.reportTemplate):
  <input type="text" id="text" [(ngModel)]="componentData.config.reportTarget">
</label>
